function insertBefore(newElement: HTMLElement, referenceElement: HTMLElement): void {
    const parentNode = referenceElement.parentNode;

    if (parentNode) {
        parentNode.insertBefore(newElement, referenceElement);
    } else {
        throw Error('referenceElement.parentNode is null');
    }
}

// ----------------------------------------------------------------------------

export default insertBefore;
